import React, { useRef, useState } from "react"
import * as Yup from "yup"
import axios from "axios"
import { FormWrapper, TextField, Button, Headline } from "@shared"
import { css, submitProgress, shouldDisable, isDone } from "@jsUtils"
import { CONTENT, CONSTANTS } from "@data"
import Styles from "./supportContactForm.module.scss"

// eslint-disable-next-line no-useless-escape
const phoneRegExp = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
const { SUBMIT } = CONSTANTS
const { CONTACT } = CONTENT

const SupportContactForm = props => {
  const { className, theme, color, inputVariant, inputStyle } = props

  const [success, setSuccess] = useState(SUBMIT.IDLE)
  const submitCountState = useRef(0)
  const formTop = useRef()

  /**
   * Handle the UI behavior for the form completion.
   * @param {number} submitCount number of submissions from Formik
   * @param {object} errs - errors object from Formik
   * @returns {void}
   */
  const statusHandler = (submitCount, errs) => {
    if (submitCount > 0 && Object.keys(errs).length > 0 && submitCount > submitCountState.current) {
      submitCountState.current = submitCount
      const topOff = formTop.current.getBoundingClientRect()
      // log("scroll to:", topOff, formTop.current, window.scrollY)
      window.scrollTo({
        top: topOff.top + window.scrollY - 85,
        left: 0,
        behavior: "smooth"
      })
    }
  }

  /**
   * Submit the form data to the contact-form endpoint
   * @param {object} data - data to submit to the form endpoint function
   * @returns {Promise} - axios promise
   */
  const submitForm = values => {
    console.log("submit support form => ", values)

    // eslint-disable-next-line no-param-reassign
    values.PBO_WebFormDataRootText = [
      {
        Text: values.SupportreqErrorMessage,
        TypeCode: "10001"
      }
    ]
    // eslint-disable-next-line no-param-reassign
    delete values.SupportreqErrorMessage
    return axios({
      url: `/.netlify/functions/support-form`,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: JSON.stringify(values)
    })
      .then(formResponse => {
        console.log("formResponse------>", formResponse)
        console.log("formResponse.status", formResponse.status)
        switch (formResponse.status) {
          case 200:
            console.log("success!")
            setSuccess(SUBMIT.SUCCESS)
            // eslint-disable-next-line no-case-declarations
            const topOff = formTop.current.getBoundingClientRect()
            window.scrollTo({
              top: topOff.top + window.scrollY - 200,
              left: 0,
              behavior: "smooth"
            })

            break
          default:
            setSuccess(SUBMIT.FAIL)
            break
        }
        return formResponse.data.status
      })
      .catch(e => {
        setSuccess(SUBMIT.FAIL)
        console.log("submitForm().catch():", e)
      })
  }

  return (
    <div
      ref={formTop}
      className={css(
        Styles.wrapper,
        className,
        !isDone(success) && Styles.active,
        isDone(success) && Styles.success
      )}
    >
      {isDone(success) ? (
        <div className={Styles.successScreen}>
          <Headline size={3} className={Styles.successHeadline}>
            Thank you for reaching out.
          </Headline>
          <Headline size={4} className={Styles.successSubhead}>
            We will be in touch soon.
          </Headline>
        </div>
      ) : (
        <FormWrapper
          className={Styles.supportContactForm}
          status={statusHandler}
          initVals={{
            FirstName: "",
            LastName: "",
            EmailAddress: "",
            MobileNum: "",
            Organization: "",
            ExoWorksSftVersion: "",
            SupportreqErrorMessage: ""
          }}
          validation={Yup.object({
            FirstName: Yup.string()
              .max(50)
              .required("Required"),
            LastName: Yup.string()
              .max(50)
              .required("Required"),
            EmailAddress: Yup.string()
              .email("Invalid email address!")
              .required("Required"),
            MobileNum: Yup.string().matches(phoneRegExp, "Phone number is not valid"),
            Organization: Yup.string()
              .max(50)
              .required("Required"),
            ExoWorksSftVersion: Yup.string().max(50),
            SupportreqErrorMessage: Yup.string().required("Required")
          })}
          submit={submitForm}
        >
          <div className={Styles.formRow}>
            <TextField
              ascope="FORMS"
              adata="FIELDS.FNAME"
              className={css(Styles.input, inputStyle)}
              theme={theme}
              color={color}
              label="First Name"
              name="FirstName"
              type="text"
              variant={inputVariant}
              placeholder="First name"
            />
            <TextField
              ascope="FORMS"
              adata="FIELDS.LNAME"
              className={css(Styles.input, inputStyle)}
              theme={theme}
              color={color}
              label="Last Name"
              name="LastName"
              type="text"
              variant={inputVariant}
              placeholder="Last name"
            />
          </div>
          <div className={Styles.formRow}>
            <TextField
              ascope="FORMS"
              adata="FIELDS.EMAIL"
              className={css(Styles.input, inputStyle)}
              theme={theme}
              color={color}
              label="Email Address"
              name="EmailAddress"
              type="email"
              variant={inputVariant}
              placeholder="example@domain.com"
            />
          </div>
          <div className={Styles.formRow}>
            <TextField
              ascope="FORMS"
              adata="FIELDS.PHONE"
              className={css(Styles.input, inputStyle)}
              theme={theme}
              color={color}
              label="Phone Number"
              name="MobileNum"
              type="text"
              variant={inputVariant}
              placeholder="(123)456-7890"
              isOptional
            />
          </div>
          <div className={Styles.formRow}>
            <TextField
              ascope="FORMS"
              adata="FIELDS.ORGANIZATION"
              className={css(Styles.input, inputStyle)}
              theme={theme}
              color={color}
              label="organization"
              name="Organization"
              type="text"
              variant={inputVariant}
              placeholder="ex. Amazon"
            />
          </div>
          <div className={Styles.formRow}>
            <TextField
              ascope="FORMS"
              adata="FIELDS.EXOVERSION"
              className={css(Styles.input, inputStyle)}
              theme={theme}
              color={color}
              label="exo works software version"
              name="ExoWorksSftVersion"
              type="text"
              variant={inputVariant}
              placeholder="Exo Works 2.1.2.4"
              isOptional
            />
          </div>
          <div className={Styles.formRow}>
            <TextField
              ascope="FORMS"
              adata="FIELDS.MESSAGE"
              className={css(Styles.input, inputStyle)}
              theme={theme}
              color={color}
              label="SUPPORT REQUEST / ERROR MESSAGE"
              name="SupportreqErrorMessage"
              type="text"
              isTextarea
              variant={inputVariant}
              placeholder="Let us know how we can help"
            />
          </div>
          <p className={Styles.notice}>
            NOTICE: Pursuant to HIPAA and other data privacy regulations, please do not disclose any
            Patient data (Patient Healthcare Information-PHI) or any Patient identifiers in this
            email. Please ensure that you follow your company policies and practices regarding
            sharing of any PHI.
          </p>

          <Button
            ascope="FORMS"
            adata="FIELDS.SUBMIT"
            className={css(Styles.submit, submitProgress(success) && Styles.work)}
            theme={theme}
            color={color}
            type="submit"
            displayCTA
            submitProps={{
              submitDone: success,
              disableButton: shouldDisable(success)
            }}
          >
            Submit
          </Button>
          {success === SUBMIT.FAIL && <p className={Styles.fail}>{CONTACT.ERROR}</p>}
          {success === SUBMIT.CAPTED && <p className={Styles.fail}>{CONTACT.CAPTED}</p>}
        </FormWrapper>
      )}
    </div>
  )
}

export default SupportContactForm
